import type { ReactNode } from "react";
import { ArrowLeft, type LucideIcon } from "lucide-react";
import { Button } from "@/components/ui/button";

interface PageHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  icon?: LucideIcon;
  onBack?: () => void;
  backDisabled?: boolean;
  actions?: ReactNode;
}

export const PageHeader = ({
  title,
  description,
  icon: Icon,
  onBack,
  backDisabled,
  actions,
}: PageHeaderProps) => (
  <div className="container mx-auto px-6 pt-6 flex flex-wrap items-center justify-between gap-4">
    <div className="flex items-center space-x-4">
      {onBack && (
        <Button
          variant="outline"
          size="icon"
          onClick={onBack}
          disabled={backDisabled}
          className="hover:bg-primary/10"
          title="Voltar"
        >
          <ArrowLeft className="h-4 w-4" />
        </Button>
      )}
      {Icon && (
        <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon className="h-5 w-5 text-primary" />
        </div>
      )}
      <div>
        <h2 className="text-2xl font-bold">{title}</h2>
        {description && (
          <p className="text-sm text-muted-foreground">{description}</p>
        )}
      </div>
    </div>
    {actions && <div className="flex items-center gap-2">{actions}</div>}
  </div>
);
